const versionTxt = localStorage.getItem('appvOrigin');

export const ignoreServerInGameVersion = '3.5.0';

export function ignoreServerInGame() {
  return versionTxt && Number(versionTxt.replaceAll('.', '')) > Number(ignoreServerInGameVersion.replaceAll('.', ''));
}

export const ignoreSupport25dGameVersion = '3.2.0';

export function ignoreSupport25d() {
  return (
    versionTxt && Number(versionTxt.replaceAll('.', '')) <= Number(ignoreSupport25dGameVersion.replaceAll('.', ''))
  );
}

export const ignoreUpgradeVersion = '3.6.2';

export function ignoreUpgrade() {
  return versionTxt && versionTxt === ignoreUpgradeVersion;
}

export const lowerVersion = '3.9.0';

export function stroageUpload() {
  return versionTxt && Number(versionTxt.replaceAll('.', '')) < Number(lowerVersion.replaceAll('.', ''));
}

export const isAuditVersion = localStorage.getItem('audit-model') === 'true' ? true : false;

export const showStart = !isAuditVersion;

export const ignoreclearSingleCacheLowVersion = '4.0.1';

export function clearSingleCache() {
  return (
    versionTxt && Number(versionTxt.replaceAll('.', '')) >= Number(ignoreclearSingleCacheLowVersion.replaceAll('.', ''))
  );
}

export const ignoreChannelVersion = '6127';

export function ignoreLive() {
  return localStorage.getItem('IGNORELIVEBYCHANNEL') ? true : false;
  // const realChannel = localStorage.getItem('channel')?.match(/^(\d+)/);
  // return realChannel && ignoreChannelVersion === realChannel[0];
}

export const ignoreBroadcastActivityVersion = '4.4.0';

export function ignoreBroadcastActivity() {
  return (
    versionTxt && Number(versionTxt.replaceAll('.', '')) < Number(ignoreBroadcastActivityVersion.replaceAll('.', ''))
  );
}
